<template>
  <div class="theme-details-inner-form">
    <h2 class="section-title-sm mb-8">{{ subscriptions }} {{ i + 2 }}</h2>

    <div class="theme-details-form__inputs-list">

      <div class="theme-details-form__language-gender-block details-section">
        <div class="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8">
          <theme-radios
            v-if="extra_tenants[i]"
            :label="locales && locales.users && locales.users.language"
            :value="extra_tenants[i].language"
            :name="`person[` + extra_tenants[i].id + `][language]`"
            :options="languages"
            v-validate="`required`"
            :isRequired="true"
          ></theme-radios>
          <theme-radios
            v-else
            :label="locales && locales.users && locales.users.language"
            :name="`new_person[` + [i] + `][language]`"
            :options="languages"
            v-validate="`required`"
            :isRequired="true"
          ></theme-radios>

          <theme-radios
            v-if="extra_tenants[i]"
            :label="locales && locales.subscriptions && locales.subscriptions.sex"
            :name="`person[` + extra_tenants[i].id + `][title_id]`"
            :options="usersTitleOptions"
            :value="extra_tenants[i].title_id"
            v-validate="`required|make_choice`"
            :isRequired="true"
          ></theme-radios>
          <theme-radios
            v-else
            :label="locales && locales.subscriptions && locales.subscriptions.sex"
            :name="`new_person[` + [i] + `][title_id]`"
            :options="usersTitleOptions"
            v-validate="`required|make_choice`"
            :isRequired="true"
          ></theme-radios>
        </div>
      </div>

      <div class="theme-details-form__income details-section">
        <h2 class="section-title-xs">{{ subscriptions }} {{ i + 2 }} {{ detailsTitle }}</h2>

        <div class="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8">
          <theme-input
            v-if="extra_tenants[i]"
            :label="usersFirstName"
            :name="`person[` + extra_tenants[i].id + `][first_name]`"
            v-model="extra_tenants[i].first_name"
            v-validate="`required|alpha_spaces_dash`"
            :isRequired="true"
            :placeholder="usersFirstNamePlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="usersFirstName"
            :name="`new_person[` + [i] + `][first_name]`"
            v-validate="`required|alpha_spaces_dash`"
            :isRequired="true"
            :placeholder="usersFirstNamePlaceholder"
          ></theme-input>

          <theme-input
            v-if="extra_tenants[i]"
            :label="usersMiddleName"
            :name="`person[` + extra_tenants[i].id + `][middle_name]`"
            v-model="extra_tenants[i].middle_name"
            :placeholder="usersMiddleNamePlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="usersMiddleName"
            :name="`new_person[` + [i] + `][middle_name]`"
            :placeholder="usersMiddleNamePlaceholder"
          ></theme-input>

          <theme-input
            v-if="extra_tenants[i]"
            :label="usersLastName"
            :name="`person[` + extra_tenants[i].id + `][last_name]`"
            v-model="extra_tenants[i].last_name"
            v-validate="`required|alpha_spaces_dash`"
            :isRequired="true"
            :placeholder="usersLastNamePlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="usersLastName"
            :name="`new_person[` + [i] + `][last_name]`"
            v-validate="`required|alpha_spaces_dash`"
            :isRequired="true"
            :placeholder="usersLastNamePlaceholder"
          ></theme-input>

          <div>
            <theme-input
              v-if="extra_tenants[i]"
              :label="usersPhoneNumber"
              :name="`person[` + extra_tenants[i].id + `][phone_number]`"
              v-model="extra_tenants[i].phone_number"
              class="js-unique-phone"
              @blur="checkPhone"
              v-validate="`required|phone_number`"
              :isRequired="true"
              :placeholder="usersPhoneNumberPlaceholder"
            ></theme-input>
            <theme-input
              v-else
              :label="usersPhoneNumber"
              :name="`new_person[` + [i] + `][phone_number]`"
              class="js-unique-phone"
              @blur="checkPhone"
              v-validate="`required|phone_number`"
              :isRequired="true"
              :placeholder="usersPhoneNumberPlaceholder"
            ></theme-input>

            <div v-if="!!is_phone_number_unique">
              <p class="text-red-600 font-semibold">{{ incomePhoneNumberAlreadyExists }}</p>
              <input type="hidden" name="phone_number_unique" v-validate="`required`" />
            </div>
          </div>

          <div>
            <theme-input
              v-if="extra_tenants[i]"
              :label="usersEmail"
              :name="`person[` + extra_tenants[i].id + `][email]`"
              v-model="extra_tenants[i].email"
              class="js-unique-mail"
              @blur="checkMail($event, extra_tenants[i].id)"
              type="email"
              v-validate="`required|email`"
              :isRequired="true"
              :placeholder="usersEmailPlaceholder"
            ></theme-input>
            <theme-input
              v-else
              :label="usersEmail"
              :name="`new_person[` + [i] + `][email]`"
              class="js-unique-mail"
              type="email"
              @blur="checkMail"
              v-validate="`required|email`"
              :isRequired="true"
              :placeholder="usersEmailPlaceholder"
            ></theme-input>

            <div v-if="is_user_already_exists == 1">
              <p class="text-red-600 font-semibold">{{ isUserAlreadyExists }}</p>
              <input type="hidden" name="user_already_exists" v-validate="`required`" />
            </div>
          </div>

          <functional-calendar
            v-if="extra_tenants[i]"
            :configs='calendarConfigs'
            v-model='birthDate'
            class='single-calendar min-w-[250px] md:w-full'
            @choseDay='changeBirthDate'
          >
            <template v-slot:datePickerInput='props'>
              <theme-input
                :label="usersDateOfBirth"
                :value="birthDate.date ? birthDate.date : ''"
                :name="`person[` + extra_tenants[i].id + `][birthdate]`"
                :isExtraInfo='true'
                :isReadonly='true'
                :placeholder="usersBirthPlaceholder"
                v-validate="`required`"
                :isRequired="true"
              >
                <template slot='extra-info'>
                  <i class='icon-calendar'/>
                </template>
              </theme-input>
            </template>
          </functional-calendar>
          <functional-calendar
            v-else
            :configs='calendarConfigs'
            v-model='birthDateNewUser'
            class='single-calendar min-w-[250px] md:w-full'
            @choseDay='changeNewUserBirthDate'
          >
            <template v-slot:datePickerInput='props'>
              <theme-input
                :label="usersDateOfBirth"
                :value="birthDateNewUserComputed"
                :name="`new_person[` + [i] + `][birthdate]`"
                :isExtraInfo='true'
                :isReadonly='true'
                :placeholder="usersBirthPlaceholder"
                v-validate="`required`"
                :isRequired="true"
              >
                <template slot='extra-info'>
                  <i class='icon-calendar'/>
                </template>
              </theme-input>
            </template>
          </functional-calendar>

          <theme-input
            v-if="extra_tenants[i]"
            :label="usersInvoiceEmail"
            :name="`person[` + extra_tenants[i].id + `][invoice_mail]`"
            v-model="extra_tenants[i].invoice_mail"
            type="email"
            v-validate="`email`"
            :placeholder="usersInvoiceEmailPlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="usersInvoiceEmail"
            :name="`new_person[` + [i] + `][invoice_mail]`"
            type="email"
            v-validate="`email`"
            :placeholder="usersInvoiceEmailPlaceholder"
          ></theme-input>

          <theme-input
            v-if="extra_tenants[i]"
            :label="usersBankAccount"
            :name="`person[` + extra_tenants[i].id + `][bank_account]`"
            v-model="extra_tenants[i].bank_account"
            :placeholder="usersBankAccountPlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="usersBankAccount"
            :name="`new_person[` + [i] + `][bank_account]`"
            :placeholder="usersBankAccountPlaceholder"
          ></theme-input>

          <theme-input
            v-if="extra_tenants[i]"
            :label="usersBic"
            :name="`person[` + extra_tenants[i].id + `][bic]`"
            v-model="extra_tenants[i].bic"
            :placeholder="usersBicPlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="usersBic"
            :name="`new_person[` + [i] + `][bic]`"
            :placeholder="usersBicPlaceholder"
          ></theme-input>
        </div>

      </div>
    
      <div class="theme-details-form__address details-section">
        <h2 class="section-title-xs">{{ subscriptions }} {{ i + 2 }} {{ addressTitle }}</h2>
          
        <div class="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8">
          <theme-input
            v-if="extra_tenants[i]"
            :name="`person[` + extra_tenants[i].id + `][address][post_code]`"
            :label="locales && locales.users && locales.users.post_code"
            @blur="checkPcHn($event, i)"
            class="js-postcode"
            v-model="extra_tenants[i].address.post_code"
            :placeholder="usersPostCodePlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :name="`new_person[` + [i] + `][address][post_code]`"
            :ref="`new_person_postcode_` + i"
            :label="locales && locales.users && locales.users.post_code"
            @blur="checkPcHn($event, i)"
            class="js-postcode"
            :placeholder="usersPostCodePlaceholder"
          ></theme-input>

          <theme-input
            v-if="extra_tenants[i]"
            :is-update-model="true"
            :name="`person[` + extra_tenants[i].id + `][address][city]`"
            :label="locales && locales.users && locales.users.city"
            v-model="extra_tenants[i].address.city"
            :placeholder="usersCityPlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :is-update-model="true"
            :name="`new_person[` + [i] + `][address][city]`"
            :ref="`new_person_city_` + i"
            :label="locales && locales.users && locales.users.city"
            :placeholder="usersCityPlaceholder"
          ></theme-input>
        </div>

        <div class="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8">
          <theme-input
            v-if="extra_tenants[i]"
            class="stretch-height"
            :name="`person[` + extra_tenants[i].id + `][address][street]`"
            :label="locales && locales.users && locales.users.street"
            v-model="extra_tenants[i].address.street"
            :placeholder="usersStreetPlaceholder"
          ></theme-input>
          <theme-input
            v-else
            class="stretch-height"
            :name="`new_person[` + [i] + `][address][street]`"
            :ref="`new_person_street_` + i"
            :label="locales && locales.users && locales.users.street"
            :placeholder="usersStreetPlaceholder"
          ></theme-input>

          <div class="col-span-1 md:col-span-2 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8">
            <theme-input
              v-if="extra_tenants[i]"
              
              :name="`person[` + extra_tenants[i].id + `][address][house_number]`"
              :label="locales && locales.users && locales.users.house_number"
              class="js-house-number stretch-height"
              @blur="checkPostcodeAddress($event, i)"
              v-model="extra_tenants[i].address.house_number"
              :placeholder="usersHouseNumberPlaceholder"
            ></theme-input>
            <theme-input
              v-else
              :name="`new_person[` + [i] + `][address][house_number]`"
              :ref="`new_person_house_number_` + i"
              :label="locales && locales.users && locales.users.house_number"
              class="js-house-number stretch-height"
              @blur="checkPostcodeAddress($event, i)"
              :placeholder="usersHouseNumberPlaceholder"
            ></theme-input>

            <!-- clarify about appenidx -->
            <theme-input
              class="stretch-height"
              :name="usersHouseNumberAppendix"
              :label="usersHouseNumberAppendixLabel"
              :placeholder="usersHouseNumberAppendixPlaceholder"
              v-model="usersHouseNumberAppendixValue"
            ></theme-input>
          </div>
        </div>

      </div>

      <div class="theme-details-form__family-status details-section">
        <h2 class="section-title-xs">{{ subscriptions }} {{ i + 2 }} {{ familyStatusTitle }}</h2>

        <theme-select
          class="max-w-[300px]"
          v-if="extra_tenants[i]"
          :label="usersCivilState"
          :value="extra_tenants[i].civil_state_id"
          :name="`person[` + extra_tenants[i].id + `][civil_state_id]`"
          :options="usersCivilStateOptions"
          v-validate="`required`"
          :isRequired="true"
        ></theme-select>
        <theme-select
          v-else
          class="max-w-[300px]"
          :label="usersCivilState"
          :name="`new_person[` + [i] + `][civil_state_id]`"
          :options="usersCivilStateOptions"
          v-validate="`required`"
          :isRequired="true"
        ></theme-select>
      </div>

      <div class="heme-details-form__income details-section">
        <h2 class="section-title-xs">{{ subscriptions }} {{ i + 2 }} {{ incomeTitle }}</h2>

        <theme-checkboxes
          v-if="extra_tenants[i]"
          :label="usersIAm"
          :name="`person[` + extra_tenants[i].id + `][type_of_income][]`"
          :options="usersTypeOfIncomeOptions"
          :values="extra_tenants[i].types_of_income_array"
          @input="triggerIncomeAdditionalForms"
          v-validate="`required|make_choice`"
          :isRequired="true"
        ></theme-checkboxes>
        <theme-checkboxes
          v-else
          :label="usersIAm"
          :name="`new_person[` + [i] + `][type_of_income][]`"
          :options="usersTypeOfIncomeOptions"
          @input="triggerIncomeAdditionalForms"
          v-validate="`required|make_choice`"
          :isRequired="true"
        ></theme-checkboxes>

        <!-- working or business -->
        <div v-if="income_form_work_business">
          <div v-if="income_form_work">
            <theme-radios
              v-if="extra_tenants[i]"
              class="mb-8"
              :label="usersContractType"
              :name="
                `person[` + extra_tenants[i].id + `][working_contract_type_id]`
              "
              v-model="extra_tenants[i].working_contract_type_id"
              :options="usersContractTypeOptions"
              @input="triggerContractDuration"
              v-validate="`required|make_choice`"
              :isRequired="true"
              :columnDirection="true"
            ></theme-radios>
            <theme-radios
              v-else
              class="mb-8"
              :label="usersContractType"
              :name="`new_person[` + [i] + `][working_contract_type_id]`"
              :options="usersContractTypeOptions"
              @input="triggerContractDuration"
              v-validate="`required|make_choice`"
              :isRequired="true"
              :columnDirection="true"
            ></theme-radios>
          </div>

          <div class="grid grid-cols-1 gap-8 mb-6 md:grid-cols-2 md:gap-8" v-if="showDuration && income_form_work">
            <theme-input
              v-if="extra_tenants[i]"
              v-model="extra_tenants[i].working_contract_duration"
              :label="usersContractDuration"
              :name="
                `person[` + extra_tenants[i].id + `][working_contract_duration]`
              "
              v-validate="`required|numeric`"
              :isRequired="true"
              :placeholder="usersContractDurationPlaceholder"
            ></theme-input>
            <theme-input
              v-else
              :label="usersContractDuration"
              :name="`new_person[` + [i] + `][working_contract_duration]`"
              v-validate="`required|numeric`"
              :isRequired="true"
              :placeholder="usersContractDurationPlaceholder"
            ></theme-input>

            <functional-calendar
              v-if="extra_tenants[i]"
              :configs='calendarConfigs'
              v-model='contractEndDate'
              class='single-calendar min-w-[250px] md:w-full'
              @choseDay='changeContractEndDate'
            >
              <template v-slot:datePickerInput='props'>
                <theme-input
                  :label="usersContractEndDate"
                  :value="contractEndDateComputed"
                  :name="`person[` + extra_tenants[i].id + `][working_contract_end_date]`"
                  :isExtraInfo='true'
                  :isReadonly='true'
                  :placeholder="usersContractEndDatePlaceholder"
                  v-validate="`required`"
                  :isRequired="true"
                >
                  <template slot='extra-info'>
                    <i class='icon-calendar'/>
                  </template>
                </theme-input>
                <input
                  type="hidden"
                  :name="`person[` + extra_tenants[i].id + `][working_contract_end_date]`"
                  :value="hiddenContractEndDate" 
                />
              </template>
            </functional-calendar>
            <functional-calendar
              v-else
              :configs='calendarConfigs'
              v-model='contractEndDateNewUser'
              class='single-calendar min-w-[250px] md:w-full'
              @choseDay='changeNewUserContractEndDate'
            >
              <template v-slot:datePickerInput='props'>
                <theme-input
                  :label="usersContractEndDate"
                  :value="contractEndDateNewUserComputed"
                  :name="`new_person[` + [i] + `][working_contract_end_date]`"
                  :isExtraInfo='true'
                  :isReadonly='true'
                  :placeholder="usersContractEndDatePlaceholder"
                  v-validate="`required`"
                  :isRequired="true"
                >
                  <template slot='extra-info'>
                    <i class='icon-calendar'/>
                  </template>
                </theme-input>
                <input
                  type="hidden"
                  :name="`new_person[` + [i] + `][working_contract_end_date]`"
                  :value="hiddenContractEndDateNewUser" 
                />
              </template>
            </functional-calendar>
          </div>

          <div class="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8">
            <theme-input
              v-if="extra_tenants[i]"
              :label="usersOccupation"
              :name="`person[` + extra_tenants[i].id + `][occupation]`"
              v-model="extra_tenants[i].occupation"
              v-validate="`required`"
              :isRequired="true"
              :placeholder="usersOccupationPlaceholder"
            ></theme-input>
            <theme-input
              v-else
              :label="usersOccupation"
              :name="`new_person[` + [i] + `][occupation]`"
              v-validate="`required`"
              :isRequired="true"
              :placeholder="usersOccupationPlaceholder"
            ></theme-input>

            <theme-input
              v-if="extra_tenants[i]"
              :label="usersMonthlyIncome"
              :name="`person[` + extra_tenants[i].id + `][income]`"
              v-model="extra_tenants[i].income"
              v-validate="`required|numeric`"
              :isRequired="true"
              :isExtraInfo="true"
              :isExtraNote="true"
              :placeholder="usersMonthlyIncomePlaceholder"
            >
              <template slot='extra-info'>€</template>
              <template slot='extra-note'>{{ usersMonthlyIncomeNote }}</template>
            </theme-input>
            <theme-input
              v-else
              :label="usersMonthlyIncome"
              :name="`new_person[` + [i] + `][income]`"
              v-validate="`required|numeric`"
              :isRequired="true"
              :isExtraInfo="true"
              :isExtraNote="true"
              :placeholder="usersMonthlyIncomePlaceholder"
            >
              <template slot='extra-info'>€</template>
              <template slot='extra-note'>{{ usersMonthlyIncomeNote }}</template>
            </theme-input>

            <theme-radios
              v-if="extra_tenants[i]"
              :label="usersDoYouHaveGuarantorGeneral"
              :name="`person[` + extra_tenants[i].id + `][guarantor]`"
              :options="usersDoYouHaveGuarantorOptions"
              :value="extra_tenants[i].guarantor + ''"
              @input="triggerGuarantorForm"
              v-validate="`required|make_choice`"
              class="md:mb-8"
            ></theme-radios>
            <theme-radios
              v-else
              :label="usersDoYouHaveGuarantorGeneral"
              :name="`new_person[` + [i] + `][guarantor]`"
              :options="usersDoYouHaveGuarantorOptions"
              @input="triggerGuarantorForm"
              v-validate="`required|make_choice`"
              class="md:mb-8"
            ></theme-radios>

            <div v-if="guarantor_form_state == 1">
              <theme-input
                v-if="extra_tenants[i]"
                :label="usersGuarantorIncome"
                :name="`person[` + extra_tenants[i].id + `][guarantor_income]`"
                v-model="extra_tenants[i].guarantor_income"
                v-validate="`required|numeric`"
                :placeholder="usersGuarantorIncomePlaceholder"
              ></theme-input>
              <theme-input
                v-else
                :label="usersGuarantorIncome"
                :name="`new_person[` + [i] + `][guarantor_income]`"
                v-validate="`required|numeric`"
                :placeholder="usersGuarantorIncomePlaceholder"
              ></theme-input>
            </div>
          </div>

        </div>

        <!-- studying -->
        <div v-if="income_form_studying">
          <div class="grid grid-cols-1 gap-5 md:grid-cols-2 mb-6 md:gap-8 md:mb-8" v-if="!income_form_work_business">
            <theme-radios
              v-if="extra_tenants[i]"
              :label="usersDoYouHaveGuarantorGeneral"
              :name="`person[` + extra_tenants[i].id + `][guarantor]`"
              :options="usersDoYouHaveGuarantorOptions"
              :value="extra_tenants[i].guarantor"
              @input="triggerGuarantorForm"
              v-validate="`required|make_choice`"
              class="md:mb-8"
            ></theme-radios>
            <theme-radios
              v-else
              :label="usersDoYouHaveGuarantorGeneral"
              :name="`new_person[` + [i] + `][guarantor]`"
              :options="usersDoYouHaveGuarantorOptions"
              @input="triggerGuarantorForm"
              v-validate="`required|make_choice`"
              class="md:mb-8"
            ></theme-radios>

            <div v-if="guarantor_form_state == 1">
              <theme-input
              v-if="extra_tenants[i]"
              :label="usersGuarantorIncome"
              :name="`person[` + extra_tenants[i].id + `][guarantor_income]`"
              v-model="extra_tenants[i].guarantor_income"
              v-validate="`required|numeric`"
              :isRequired="true"
              :placeholder="usersGuarantorIncomePlaceholder"
            ></theme-input>
            <theme-input
              v-else
              :label="usersGuarantorIncome"
              :name="`new_person[` + [i] + `][guarantor_income]`"
              v-validate="`required|numeric`"
              :isRequired="true"
              :placeholder="usersGuarantorIncomePlaceholder"
            ></theme-input>
            </div>
          </div>
          <theme-input
            v-if="extra_tenants[i]"
            :label="usersStudy"
            :name="`person[` + extra_tenants[i].id + `][study]`"
            v-model="extra_tenants[i].study"
            v-validate="`required`"
            :isRequired="true"
            :placeholder="usersStudyPlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="usersStudy"
            :name="`new_person[` + [i] + `][study]`"
            v-validate="`required`"
            :isRequired="true"
            :placeholder="usersStudyPlaceholder"
          ></theme-input>

        </div>

        <div v-if="income_form_any">
          <theme-textarea
            v-if="extra_tenants[i]"
            :label="usersExtraInformationIncome"
            :name="`person[` + extra_tenants[i].id + `][income_note]`"
            v-model="extra_tenants[i].income_note"
            :placeholder="usersExtraInformationIncomePlaceholder"
          ></theme-textarea>
          <theme-textarea
            v-else
            :label="usersExtraInformationIncome"
            :name="`new_person[` + [i] + `][income_note]`"
            :placeholder="usersExtraInformationIncomePlaceholder"
          ></theme-textarea>
        </div>
      </div>

      <div class="theme-details-form__living-situation details-section">
        <h2 class="section-title-xs">{{ subscriptions }} {{ i + 2 }} {{ usersLandlordLabel }}</h2>

        <theme-radios
          v-if="extra_tenants[i]"
          :name="`person[` + extra_tenants[i].id + `][landlord_status]`"
          :options="usersLandlordOptions"
          v-model="extra_tenants[i].landlord_status"
          :columnDirection="true"
          @input="triggerLandlordType"
        ></theme-radios>
        <theme-radios
          v-else
          :name="`new_person[` + [i] + `][landlord_status]`"
          :options="usersLandlordOptions"
          :columnDirection="true"
          @input="triggerLandlordType"
        ></theme-radios>

        <div class="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8" v-if="landlord_type_state == 'renting_property'">
          <theme-input
            v-if="extra_tenants[i]"
            :label="locales && locales.users && locales.users.landlord_name"
            :name="`person[` + extra_tenants[i].id + `][landlord_name]`"
            :placeholder="usersLandlordNamePlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="locales && locales.users && locales.users.landlord_name"
            :name="`new_person[` + [i] + `][landlord_name]`"
            :placeholder="usersLandlordNamePlaceholder"
          ></theme-input>

          <theme-input
            v-if="extra_tenants[i]"
            :label="locales && locales.users && locales.users.landlord_email"
            :name="`person[` + extra_tenants[i].id + `][landlord_email]`"
            v-validate="`email`"
            :placeholder="usersLandlordEmailPlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="locales && locales.users && locales.users.landlord_email"
            :name="`new_person[` + [i] + `][landlord_email]`"
            v-validate="`email`"
            :placeholder="usersLandlordEmailPlaceholder"
          ></theme-input>

          <theme-input
            v-if="extra_tenants[i]"
            :label="
              locales && locales.users && locales.users.landlord_phone_number
            "
            :name="
              `person[` + extra_tenants[i].id + `][landlord_phone_number]`
            "
            v-validate="`phone_number`"
            :placeholder="usersLandlordPhonePlaceholder"
          ></theme-input>
          <theme-input
            v-else
            :label="
              locales && locales.users && locales.users.landlord_phone_number
            "
            :name="`new_person[` + [i] + `][landlord_phone_number]`"
            v-validate="`phone_number`"
            :placeholder="usersLandlordPhonePlaceholder"
          ></theme-input>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { FunctionalCalendar } from 'vue-functional-calendar';
import { mapGetters } from "vuex";
export default {
  inject: ["$validator"],
  components: { FunctionalCalendar },
  data() {
    return {
      birthDate: { date: this.extraTenants[this.i] && this.extraTenants[this.i].bDate },
      birthDateNewUser: { date: '' },
      contractEndDate: { date: this.extraTenants[this.i] && this.extraTenants[this.i].wced},
      contractEndDateNewUser: { date: '' },
      income_form_any: false,
      income_form_studying: false,
      income_form_work: false,
      income_form_work_business: false,
      extra_tenants: this.extraTenants,
      income_form_all_states: this.incomeFormAllStates,
      income_form_state: -1,
      guarantor_form_state: -1,
      is_user_already_exists: 0,
      landlord_type_state: this.landlordTypeState,
      showDuration: false,
      is_phone_number_unique: 0,
      hiddenContractEndDate: this.extraTenants[this.i] && moment(this.extraTenants[this.i].wced,'DD/MM/YYYY').format('YYYY-MM-DD'),
      hiddenContractEndDateNewUser: '',

      calendarConfigs: {
        dateFormat: 'dd-mm-yyyy',
        isModal: true,
        isDatePicker: true,
        isAutoCloseable: true,
        changeYearFunction: true,
      },
    };
  },
  computed: {
    ...mapGetters(["locales"]),
    birthDateComputed: function() {
      return this.birthDate.date ? this.birthDate.date : '';
    },
    birthDateNewUserComputed: function() {
      return this.birthDateNewUser.date ? this.birthDateNewUser.date : '';
    },
    contractEndDateComputed: function() {
      return this.contractEndDate.date ? this.contractEndDate.date : '';
    },
    contractEndDateNewUserComputed: function() {
      return this.contractEndDateNewUser.date ? this.contractEndDateNewUser.date : '';
    },
  },
  props: {
    i: {
      default: 0,
      type: Number,
    },
    subscriptions: {
      default: "",
      type: String,
    },
    extraTenants: {
      default: () => {},
      type: [Object, Array],
    },
    usersFirstName: {
      default: "",
      type: String,
    },
    usersTitleOptions: {
      default: () => {},
      type: Object,
    },
    usersMiddleName: {
      default: "",
      type: String,
    },
    usersLastName: {
      default: "",
      type: String,
    },
    usersDateOfBirth: {
      default: "",
      type: String,
    },
    usersPhoneNumber: {
      default: "",
      type: String,
    },
    usersEmail: {
      default: "",
      type: String,
    },
    usersInvoiceEmail: {
      default: "",
      type: String,
    },
    usersBankAccount: {
      default: "",
      type: String,
    },
    usersBic: {
      default: "",
      type: String,
    },
    usersCivilState: {
      default: "",
      type: String,
    },
    usersCivilStateOptions: {
      default: () => {},
      type: Object,
    },
    usersIAm: {
      default: "",
      type: String,
    },
    usersTypeOfIncomeOptions: {
      default: () => {},
      type: Object,
    },
    usersTypeOfIncomeSlugs: {
      default: () => {},
      type: Object,
    },
    usersContractType: {
      default: "",
      type: String,
    },
    usersContractTypeInput: {
      default: "",
      type: String,
    },
    usersContractTypeOptions: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractTypeAttributes: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractDuration: {
      default: "",
      type: String,
    },
    usersContractDurationInput: {
      default: "",
      type: String,
    },
    usersContractEndDate: {
      default: "",
      type: String,
    },
    usersContractEndDateInput: {
      default: "",
      type: String,
    },
    usersOccupation: {
      default: "",
      type: String,
    },
    usersMonthlyIncome: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeNote: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantor: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorGeneral: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorOptions: {
      default: () => {},
      type: Object,
    },
    usersDoYouHaveOtherGuaranteeOptions: {
      default: "",
      type: String,
    },
    usersDoYouHaveOtherGuaranteeOptionsOptions: {
      default: () => {},
      type: Object,
    },
    usersGuarantorIncome: {
      default: "",
      type: String,
    },
    usersStudy: {
      default: "",
      type: String,
    },
    usersExtraInformationIncome: {
      default: "",
      type: String,
    },
    incomeFormAllStates: {
      default: () => [],
      type: Array,
    },
    incomeTitle: {
      default: "",
      type: String,
    },
    landlordTypeState: {
      default: "-1",
      type: String,
    },
    usersLandlordOptions: {
      default: () => {},
      type: Object,
    },
    isUserAlreadyExists: {
      default: "",
      type: String,
    },
    isUserBanned: {
      default: "",
      type: String,
    },
    incomePhoneNumberAlreadyExists: {
      default: "",
      type: String,
    },
    detailsTitle: {
      default: "",
      type: String,
    },
    addressTitle: {
      default: "",
      type: String,
    },
    familyStatusTitle: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
    usersHouseNumberAppendix: {
      default: "",
      type: String,
    },
    usersHouseNumberAppendixLabel: {
      default: "",
      type: String,
    },
    usersHouseNumberAppendixPlaceholder: {
      default: "",
      type: String,
    },
    usersHouseNumberAppendixValue: {
      default: "",
      type: String,
    },
    usersHouseNumberAppendixExtra: {
      default: "",
      type: String,
    },
    usersHouseNumberAppendixExtraLabel: {
      default: "",
      type: String,
    },
    usersHouseNumberAppendixExtraPlaceholder: {
      default: "",
      type: String,
    },
    usersHouseNumberAppendixExtraValue: {
      default: "",
      type: String,
    },
    usersLandlordLabel: {
      default: "",
      type: String,
    },
    usersFirstNamePlaceholder: {
      default: "",
      type: String,
    },
    usersMiddleNamePlaceholder: {
      default: "",
      type: String,
    },
    usersLastNamePlaceholder: {
      default: "",
      type: String,
    },
    usersPhoneNumberPlaceholder: {
      default: "",
      type: String,
    },
    usersEmailPlaceholder: {
      default: "",
      type: String,
    },
    usersBirthPlaceholder: {
      default: "",
      type: String,
    },
    usersInvoiceEmailPlaceholder: {
      default: "",
      type: String,
    },
    usersBankAccountPlaceholder: {
      default: "",
      type: String,
    },
    usersBicPlaceholder: {
      default: "",
      type: String,
    },
    usersPostCodePlaceholder: {
      default: "",
      type: String,
    },
    usersCityPlaceholder: {
      default: "",
      type: String,
    },
    usersStreetPlaceholder: {
      default: "",
      type: String,
    },
    usersContractDurationPlaceholder: {
      default: "",
      type: String,
    },
    usersContracEndDatePlaceholder: {
      default: "",
      type: String,
    },
    usersOccupationPlaceholder: {
      default: "",
      type: String,
    },
    usersMonthlyIncomePlaceholder: {
      default: "",
      type: String,
    },
    usersGuarantorIncomePlaceholder: {
      default: "",
      type: String,
    },
    usersStudyPlaceholder: {
      default: "",
      type: String,
    },
    usersExtraInformationIncomePlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordNamePlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordPhonePlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordEmailPlaceholder: {
      default: "",
      type: String,
    },
    usersHouseNumberPlaceholder: {
      default: "",
      type: String,
    },
    usersContractEndDatePlaceholder: {
      default: "",
      type: String,
    },
  },
  methods: {
    triggerIncomeAdditionalForms: function (value) {
      if (value) {
        this.income_form_state = value;
      } else {
        if (this.extraTenants[this.i]) {
          this.income_form_state =
            this.extraTenants[this.i].types_of_income_array;
        } else {
          this.income_form_state = -1;
        }
      }

      this.income_form_any = false;
      this.income_form_studying = false;
      this.income_form_work_business = false;
      this.income_form_work = false;

      for (var i = 0; i < this.income_form_state.length; i++) {
        var state = this.usersTypeOfIncomeSlugs[this.income_form_state[i]];

        if (this.income_form_all_states.indexOf(state) > -1) {
          this.income_form_any = true;
          if (state == "own_business" || state == "working") {
            this.income_form_work_business = true;
          }
          if (state == "working") {
            this.income_form_work = true;
          }
          if (state == "studying") {
            this.income_form_studying = true;
          }
        }
      }
    },
    triggerContractDuration: function (value) {
      this.showDuration = false;
      if (value) {
        var option = this.usersContractTypeAttributes[value];
        if (option == "1") {
          this.showDuration = true;
        }
      } else {
        if (this.extraTenants[this.i]) {
          var option =
            this.usersContractTypeAttributes[
              this.extraTenants[this.i].working_contract_type_id
            ];
          if (option == "1") {
            this.showDuration = true;
          }
        }
      }
    },
    triggerGuarantorForm: function (value) {
      if (value) {
        if (value !== true) {
          this.guarantor_form_state = value;
        } else {
          this.guarantor_form_state = -1;
        }
      } else {
        if (this.extraTenants[this.i]) {
          this.guarantor_form_state = this.extraTenants[this.i].guarantor;
        } else {
          this.guarantor_form_state = -1;
        }
      }
    },
    triggerLandlordType: function (value) {
      this.landlord_type_state = value;
    },
    checkMail: function (event, id = null) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;
      var data = {
        email: email,
      };
      if (id) {
        data.id = id;
      }
      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: data,
        success: function (result) {
          vm.is_user_already_exists = +result;
          if (result == 0) {
            var elements = document.getElementsByClassName("js-unique-mail");
            var mails = [];
            Array.prototype.forEach.call(elements, function (el) {
              // Do stuff here
              let val = el.querySelector("input").value;
              if (el.querySelector("input") != event.target && val != "") {
                mails.push(val);
              }
            });
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function () {},
      });
    },
    checkPhone: function (event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName("js-unique-phone");
      var phones = [];
      Array.prototype.forEach.call(elements, function (el) {
        // Do stuff here
        let val = el.querySelector("input").value;
        if (el.querySelector("input") != event.target && val != "") {
          phones.push(val);
        }
      });
      if (phones.length && phones.indexOf(phone) != -1) {
        vm.is_phone_number_unique = 1;
      } else {
        vm.is_phone_number_unique = 0;
      }
    },
    checkPcHn(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        if (that.extra_tenants[i]) {
          var postcode = $(
            "[name='person[" +
              that.extra_tenants[i].id +
              "][address][post_code]']"
          )
            .first()
            .val();
          var house_number = $(
            "[name='person[" +
              that.extra_tenants[i].id +
              "][address][house_number]']"
          )
            .first()
            .val();
          if (postcode && postcode != "") {
            $.post(
              "/get-street-location",
              {
                postcode: postcode,
                house_number: house_number,
              },
              function (data) {
                if (data.error == "false") {
                  $(
                    "[name='person[" +
                      that.extra_tenants[i].id +
                      "][address][city]']"
                  )
                    .first()
                    .val(data.location);
                  that.extra_tenants[i].address.city = data.location;
                  $(
                    "[name='person[" +
                      that.extra_tenants[i].id +
                      "][address][street]']"
                  )
                    .first()
                    .val(data.street);
                  that.extra_tenants[i].address.street = data.street;
                }
              },
              "json"
            );
          }
        } else {
          var postcode = $(
            "[name='new_person[" + [i] + "][address][post_code]']"
          )
            .first()
            .val();
          var house_number = $(
            "[name='new_person[" + [i] + "][address][house_number]']"
          )
            .first()
            .val();
          if (postcode && postcode != "") {
            $.post(
              "/get-street-location",
              {
                postcode: postcode,
                house_number: house_number,
              },
              function (data) {
                if (data.error == "false") {
                  $("[name='new_person[" + [i] + "][address][city]']")
                    .first()
                    .val(data.location);
                  $("[name='new_person[" + [i] + "][address][street]']")
                    .first()
                    .val(data.street);
                  var ref1 = "new_person_street_" + i;
                  var ref2 = "new_person_city_" + i;
                  that.$refs[ref1].model = data.street;
                  that.$refs[ref2].model = data.location;
                }
              },
              "json"
            );
          }
        }
      }, 100);
    },
    checkPostcodeAddress(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        if (that.extra_tenants[i]) {
          var street = $(
            "[name='person[" + that.extra_tenants[i].id + "][address][street]']"
          )
            .first()
            .val();
          var house_number = $(
            "[name='person[" +
              that.extra_tenants[i].id +
              "][address][house_number]']"
          )
            .first()
            .val();
          var location = $(
            "[name='person[" + that.extra_tenants[i].id + "][address][city]']"
          )
            .first()
            .val();
          if (street != "" && house_number != "") {
            $.post(
              `/get-postcode-by-address`,
              {
                street: street,
                house_number: house_number,
                location: location,
              },
              function (data) {
                if (data.error == "false") {
                  $(
                    "[name='person[" +
                      that.extra_tenants[i].id +
                      "][address][post_code]']"
                  )
                    .first()
                    .val(data.postcode);
                  that.extra_tenants[i].address.post_code = data.postcode;
                }
              },
              "json"
            );
          }
        } else {
          var street = $("[name='new_person[" + [i] + "][address][street]']")
            .first()
            .val();
          var house_number = $(
            "[name='new_person[" + [i] + "][address][house_number]']"
          )
            .first()
            .val();
          var location = $("[name='new_person[" + [i] + "][address][city]']")
            .first()
            .val();
          if (street != "" && house_number != "") {
            $.post(
              `/get-postcode-by-address`,
              {
                street: street,
                house_number: house_number,
                location: location,
              },
              function (data) {
                if (data.error == "false") {
                  $("[name='new_person[" + [i] + "][address][post_code]']")
                    .first()
                    .val(data.postcode);
                  var ref1 = "new_person_postcode_" + i;
                  that.$refs[ref1].model = data.postcode;
                }
              },
              "json"
            );
          }
        }
      }, 100);
    },
    changeBirthDate: function (value) {
      this.birthDate = { date: value.date };
    },
    changeNewUserBirthDate: function (value) {
      this.birthDateNewUser = { date: value.date };
    },
    changeContractEndDate: function (value) {
      this.contractEndDate = { date: value.date };
      this.hiddenContractEndDate = moment(value.date,'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    changeNewUserContractEndDate: function (value) {
      this.contractEndDateNewUser = { date: value.date };
      this.hiddenContractEndDateNewUser = moment(value.date,'DD/MM/YYYY').format('YYYY-MM-DD');
    },
  },
  beforeMount() {
    this.triggerIncomeAdditionalForms();
    this.triggerGuarantorForm();
    this.triggerContractDuration();
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/components/ThemeDetailsInnerForm.vue